<template>
  <div class="content">
    <Background>
      <FriendlierCard>
        <div class="padded-block">
          <div class="logo">
            <LocaleAwareLogo variant="primary" color="cloud" />
          </div>
          
          <div class="success-section">
            <div class="success-icon">✅</div>
            <div class="title">{{ t("donationSuccess.title") }}</div>
            <div class="subtitle">
              {{ t("donationSuccess.thank-you", { charityName }) }}
            </div>
            <div class="details">
              <p>{{ t("donationSuccess.processed") }}</p>
              <p>{{ t("donationSuccess.confirmation-email") }}</p>
            </div>
            
            <div class="button-container">
              <button class="button primary-button" @click="goHome">
                {{ t("donationSuccess.return-home") }}
              </button>
            </div>
          </div>
        </div>
      </FriendlierCard>
    </Background>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import {
  Background,
  FriendlierCard,
  LocaleAwareLogo,
} from "@/revamp/components";

const Router = useRouter();
const route = useRoute();
const { t } = useI18n();

const charityName = computed(() => route.query.charityName || "the selected charity");

onMounted(() => {
  window.history.replaceState({}, document.title, "/donation-success");
});

function goHome() {
  Router.replace("/return");
}
</script>

<style scoped lang="scss">
@import "@/revamp/assets/scss/colors.scss";
@import "@/revamp/assets/scss/elements.scss";
@import "@/revamp/assets/scss/variables.scss";

.success-section {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 15px;
  text-align: center;
  
  .success-icon {
    font-size: 4rem;
    margin-bottom: 20px;
  }
  
  .title {
    font-size: 2rem;
    color: $sunflower;
    width: 100%;
    margin-bottom: 15px;
    font-weight: bold;
  }
  
  .subtitle {
    font-size: 1.2rem;
    color: $denim;
    width: 100%;
    margin-bottom: 30px;
  }
  
  .details {
    margin-bottom: 30px;
    
    p {
      color: $cloud;
      font-size: 1rem;
      margin-bottom: 10px;
      line-height: 1.4;
    }
  }
}

.button-container {
  text-align: center;
  
  .button {
    padding: 15px 30px;
    border-radius: 10px;
    border: none;
    font-weight: bold;
    font-size: 1.1rem;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .primary-button {
    background-color: $sunflower;
    color: $denim;
    
    &:hover {
      background-color: darken($sunflower, 10%);
    }
  }
}

.logo {
  max-width: 30%;
  min-width: 100%;
}
</style>